import React, { useState, useEffect } from "react";
import { Container, Flex, Heading, Box, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import ProfilePicture from "../atoms/ProfilePicture";

const About = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      <Box
        as="section"
        id="about"
        className="scroll-section"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        minH="100vh"
        h="100vh"
        background="#F9F0DF"
        overflow={"hidden"}
      >
        <Flex zIndex={1} h="100vh" justifyContent="center" position="relative">
          <Flex direction="column" gap={0} zIndex="5" pos="relative" id="aboutme">
            <Container maxW="1920px" px={{ base: 4, lg: 6 }} pt={12} zIndex={1}>
              <Flex
                direction={{ base: "column", lg: "row" }}
                justifyContent="center"
                align={"center"}
              >
                <Flex
                  direction={{ base: "column-reverse", lg: "row" }}
                  justifyContent="center"
                  align={"center"}
                >
                  <motion.div
                    whileInView={{ opacity: 1, y: isMobile ? "-7rem" : "0" }}
                    transition={{ ease: "linear", delay: 0.4 }}
                    h="100%"
                    style={{ opacity: 0, y: "2vw" }}
                  >
                    <Flex
                      direction="column"
                      gap={6}
                      justifyContent="center"
                      w={{ base: "100%", lg: "20vw", xl: "25vw" }}
                      px="2"
                      textAlign={{ base: "justify", lg: "justify" }}
                      position="relative"
                      display="flex"
                      alignItems={{ base: "center", lg: "flex-start" }}
                    >
                      <Heading
                        as="h1"
                        fontSize={{ base: "35px", md: "35px", lg: "25px", xl: "45px" }}
                        display={"flex"}
                        zIndex={40}
                        // textTransform={"uppercase"}
                        backgroundBlendMode="multiply"
                        color={"#333333"}
                        bgBlendMode={"multiply"}
                        textAlign={{ base: "center", lg: "start" }}
                        flexDir={{ base: "row", lg: "column" }}
                        alignContent="center"
                        blendMode={"difference"}
                      >
                        <span
                          style={{
                            padding: "5px 20px",
                            color: "#F9F0DF",
                            background: "#333333",
                            fontWeight: "400",
                            width: "fit-content",
                            borderRadius: "15px 15px 0 15px",
                          }}
                        >
                          Hello!
                        </span>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <span
                            style={{
                              padding: "5px 20px",
                              fontWeight: "400",
                              width: "fit-content",
                              display: "flex",
                              justifyContent: "left",
                            }}
                          >
                            I'm
                          </span>
                          <span
                            style={{
                              padding: "5px 20px",
                              color: "#F9F0DF",
                              background: "#333333",
                              fontWeight: "400",
                              width: "fit-content",
                              borderRadius: "0 15px 15px 15px",
                              display: "flex",
                              justifyContent: "left",
                            }}
                          >
                            Nathan
                          </span>
                        </div>
                      </Heading>
                      <Text lineHeight={{ base: "1", md: "1.2" }} fontWeight="400" color="#333333">
                        Brazilian creative based in Amsterdam, combining graphic design, UX/UI, and
                        front-end skills to build clear, engaging visuals and interfaces. I also
                        work with video and motion graphics, bringing ideas to life with dynamic,
                        polished content.
                      </Text>
                    </Flex>
                  </motion.div>
                  <motion.div
                    style={{
                      opacity: 0,
                      borderRadius: "0 0 400px 400px",
                      y: "-144px",
                      height: "fit-content",
                      overflow: "hidden",
                      margin: "0 20px",
                      top: "0",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    transition={{ ease: "linear", delay: 0.2, duration: 0.5 }}
                    viewport={{ amount: 0.5 }}
                    whileInView={{
                      opacity: 1,
                      y: isMobile ? "-8rem" : "-100px",
                      transition: { duration: 0.5, ease: "easeInOut", delay: 0.5 },
                    }}
                  >
                    <ProfilePicture />
                  </motion.div>
                </Flex>
                <motion.div
                  whileInView={{ opacity: 1, y: isMobile ? "-6rem" : "0" }}
                  transition={{ ease: "linear", delay: 0.4 }}
                  h="100%"
                  style={{ opacity: 0, y: "-5rem" }}
                >
                  <Flex
                    direction="column"
                    gap={6}
                    justifyContent="center"
                    w={{ base: "100%", lg: "20vw", xl: "25vw" }}
                    px="5"
                    textAlign={{ base: "center", lg: "justify" }}
                    border={"1px dashed #333333"}
                    alignItems={"center"}
                    borderRadius="2xl"
                  >
                    <Text
                      display="flex"
                      lineHeight="1.375"
                      fontWeight="400"
                      color="#333333"
                      flexDir={{ base: "row", lg: "column" }}
                      alignItems="start"
                      justifyContent={{ base: "center", lg: "flex-start" }}
                      w={"fit-content"}
                    >
                      <Box as="span" display={"flex"} flexDir={"row"} alignItems="center">
                        <Text
                          as="span"
                          fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                          fontWeight="600"
                          mr={2}
                        >
                          +12
                        </Text>
                        <Text as="span" fontSize={{ base: "md", md: "lg", lg: "xl" }} mr={4}>
                          years
                        </Text>
                      </Box>
                      <Box as="span" display={"flex"} flexDir={"row"} alignItems="center">
                        <Text
                          as="span"
                          fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                          fontWeight="600"
                          mr={2}
                        >
                          +100
                        </Text>
                        <Text as="span" fontSize={{ base: "md", md: "lg", lg: "xl" }} mr={4}>
                          projects
                        </Text>
                      </Box>
                      <Box as="span" display={"flex"} flexDir={"row"} alignItems="center">
                        <Text
                          as="span"
                          fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                          fontWeight="600"
                          mr={2}
                        >
                          +55
                        </Text>
                        <Text as="span" fontSize={{ base: "md", md: "lg", lg: "xl" }}>
                          happy clients
                        </Text>
                      </Box>
                    </Text>
                  </Flex>
                </motion.div>
              </Flex>
            </Container>
          </Flex>
        </Flex>
      </Box>
    </>
  );
};

export default React.memo(About);
